import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=65091c4e&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style1 from "./Order.vue?vue&type=style&index=1&id=65091c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65091c4e",
  null
  
)

export default component.exports